import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { View } from 'react-native'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

interface EmptyStateProps {
    title: string
    description: string
}

const EmptyState: FC<EmptyStateProps> = ({ title, description }) => {
    const { styles } = useStyles(stylesheet)

    return (
        <View style={styles.container}>
            <Typography.Heading variant="h2" style={styles.text}>
                {title}
            </Typography.Heading>
            <Typography.Heading variant="h2" style={styles.text}>
                {description}
            </Typography.Heading>
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
    },
    text: {
        color: ColorEnum.JET_100,
        textAlign: 'center',
    },
})

export default EmptyState
